import { render, staticRenderFns } from "./kiosk-re-locale-select.vue?vue&type=template&id=6752093d&scoped=true&"
import script from "./kiosk-re-locale-select.vue?vue&type=script&lang=js&"
export * from "./kiosk-re-locale-select.vue?vue&type=script&lang=js&"
import style0 from "./kiosk-re-locale-select.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./kiosk-re-locale-select.vue?vue&type=style&index=1&id=6752093d&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6752093d",
  null
  
)

export default component.exports